import React, { useEffect, useState } from 'react';

// Styles & Assets
import styles from './ClinicalCourse.module.css';

import { Patient } from '../../interfaces/Patient';

// Other
import { useOutletContext, useParams } from 'react-router-dom';
import Modal from '../../components/UI/Modal/Modal';
import ResultsPollPatientDialog from '../../components/PatientPollsPage/ResultsPollPatientDialog/ResultsPollPatientDialog';
import { useTranslation } from 'react-i18next';

const ClinicalCoursePage: React.FC = () => {

    // Hooks
    const { patient }: { patient: Patient } = useOutletContext();
    const { id } = useParams();
    const { i18n } = useTranslation();

    const hospitalCase = patient?.cases?.find(caso => caso.id === Number(id))?.hospital_case ?? '';

    const url = window.config.CLINICAL_COURSE_URL.replace('USER_UUID', patient.pid_1 ?? '').replace('HOSPITAL_CASE', hospitalCase) + `&len=${i18n.language.toLocaleUpperCase()}`;

    const [showResultsPoll, setShowResultsPoll] = useState(false);

    const [patientInquiriesID, setPatientInquiriesID] = useState<number | null>(null);

    useEffect(() => {
        window.addEventListener(
            'message',
            (event) => {
                if (event.data?.action === 'open-result-popup') {
                    setPatientInquiriesID(event.data?.data?.patient_inquiries_id ?? null);
                    setShowResultsPoll(true);
                }
            },
            false,
        );
    }, []);

    return (
        <div className={styles.container}>
            <iframe
                className={styles.iframe}
                src={url}
                title="Embedded Iframe"
            />
            <Modal show={showResultsPoll} setShowModal={setShowResultsPoll} >
                {patientInquiriesID !== null &&
                    <ResultsPollPatientDialog
                        patient_id={patient.id}
                        patientInquiriesID={patientInquiriesID}
                        setShowDialog={setShowResultsPoll}
                    />
                }
            </Modal>
        </div>
    );
};

export default ClinicalCoursePage;